(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-info-tabs"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sectionId = "{{ section.id }}";
  const container = document.querySelector(`.custom-product-tabs-container[data-section-id="${sectionId}"]`);
  if (!container) {
    // console.warn(`Custom Product Tabs: Container not found for section ${sectionId}`);
    return;
  }

  const tabLinks = container.querySelectorAll('.tab-link');
  const tabContents = container.querySelectorAll('.tab-content-item');

  if (tabLinks.length === 0) {
    // console.warn(`Custom Product Tabs: No tab links found in section ${sectionId}`);
    return;
  }

  function activateTab(targetTabId) {
    let tabFound = false;
    tabLinks.forEach(link => {
      link.classList.remove('active');
      if (link.dataset.tab === targetTabId) {
        link.classList.add('active');
        tabFound = true;
      }
    });

    let contentFound = false;
    tabContents.forEach(content => {
      content.classList.remove('active'); // Hide all content first
      // The content ID includes the section ID for uniqueness
      if (content.id === `${targetTabId}-content-${sectionId}`) {
        content.classList.add('active');
        contentFound = true;
      }
    });
    // if (!tabFound) console.warn(`Custom Product Tabs: Tab link not found for ID "${targetTabId}" in section ${sectionId}`);
    // if (!contentFound) console.warn(`Custom Product Tabs: Tab content not found for ID "${targetTabId}-content-${sectionId}" in section ${sectionId}`);
  }

  tabLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const targetTab = this.dataset.tab;
      activateTab(targetTab);
    });
  });

  // Activate the first visible and enabled tab by default
  let firstActiveTab = null;
  for (let i = 0; i < tabLinks.length; i++) {
    const tabId = tabLinks[i].dataset.tab;
    // Check if the corresponding enable setting is true (e.g., section.settings.enable_tab1)
    // This check needs to be done carefully as we can't directly access section.settings in JS here
    // We rely on the Liquid to not render the tab link if it's disabled.
    // So, if the tab link exists, we assume its corresponding content *should* exist if enabled.
    const contentElement = container.querySelector(`#${tabId}-content-${sectionId}`);
    if (contentElement) { // Check if the content div for this tab exists
        firstActiveTab = tabId;
        break;
    }
  }

  if (firstActiveTab) {
    activateTab(firstActiveTab);
  } else if (tabLinks.length > 0) {
    // Fallback: if no specific tab could be determined as active (e.g. all disabled by settings but links still rendered - unlikely with proper Liquid)
    // activate the very first tab link found.
    // activateTab(tabLinks[0].dataset.tab);
    // console.warn(`Custom Product Tabs: No enabled tabs found with content. Defaulting to first tab link if available, or none. Section: ${sectionId}`);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
